<template>
  <div>
    <v-layout pa-4>
      {{ error }}
      <form @submit.prevent="sendFile" enctype="multipart/form-data">
        <input
          id="file_input"
          type="file"
          @change="check_image($event)"
          accept="image/*"
        />
        <v-btn color="primary" :disabled="file === null" @click="sendFile">Subir</v-btn>
        <br />
        <br />
        <p class="body-2 font-weight-medium text-md-left">
          <b>Los requisitos para cambiar tu foto son los siguientes:</b>
          <br />
          <br />• Foto tipo carnet a color tomada de frente y con el fondo blanco.
          <br />• Imagen de buena calidad
          <br />• Foto tomada en un periodo no superior a 6 meses
          <br />• Expresión de cara neutral y con los ojos abiertos
          <br />• Foto con vestimenta de trabajo
          <br />• No utilizar sombreros, pañuelos, lentes oscuros, audífonos u otros accesorios.
          <br />• Resolución de 250 x 250 px
          <br />• Peso de archivo no superior a 200 Kb
          <br />
        </p>
      </form>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "SimpleUpload",
  data() {
    return {
      file: null,
      error: null,
    };
  },
  computed: {
    ...mapState("user", ["current_user"])
  },
  methods: {
    ...mapActions("user", ["fetchSelectedUser", "fetchCurrentUser"]),
    ...mapMutations("api_menu", ["setMenu"]),
    ...mapActions("api_menu", ["fetchMenu"]),
    sendFile() {
      Swal.fire({ title: "Estamos cargando su petición..." });
      Swal.showLoading();
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("user_id", this.current_user.id);
      try {
        axios.post("/frontend/users/upload", formData);
        Swal.fire({
          title:
            "Foto enviada con éxito y pasará por un proceso de validación antes de ser publicada."
        });
        this.$emit("exit", true);
      } catch (err) {
        // console.log(err);
      }
      setTimeout(
        () => this.fetchCurrentUser(this.current_user.full_legal_number),
        900
      );
      this.fetchMenu(this.current_user.full_legal_number);
    },
    check_image(e) {
      const typeFile = e.target.files[0].type;
      const sizeFile = e.target.files[0].size;
      const file_input = document.getElementById("file_input");

      // Validando tipo de imagen
      if (typeFile === 'image/jpeg' || typeFile === 'image/png') {
        this.file = e.target.files[0];
        this.error = null;
      } else {
        this.file = null;
        this.error = 'Archivo no válido';
        file_input.value = '';
        Swal.fire({
          title: "Por favor elegir formato de imagen"
        });
        return;
      }
      // Validando tamaño de archivo
      if (sizeFile > 200000) {
        this.file = null;
        this.error = 'Archivo supera los 200kb';
        file_input.value = '';
        Swal.fire({
          title: "Por favor seleccione una imágen con un peso máximo de 200Kb",
          imageUrl: require('@/assets/default-person.jpg'),
          imageWidth: 300,
          imageHeight: 270
        });
        return;
      } 

      // Validando dimensiones de imagen
      const reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = evt => {
        let img = new Image();
        img.src = window.URL.createObjectURL(this.file)
        img.onload = () => {
          if (img.width > 250 || img.height > 250) {
            this.file = null;
            this.error = 'Imagen supera los 250px';
            file_input.value = '';
            Swal.fire({
              title: "Por favor seleccione una imágen de tamaño 250px x 250px",
              imageUrl: require('@/assets/default-person.jpg'),
              imageWidth: 300,
              imageHeight: 270
            });
            return;
          }
        }

        img.src = evt.target.result;
      }
    }
  }
};
</script>